/**
 * Central definition for task type styling.
 * Single source of truth for:
 * - Calendar event colors
 * - Agenda filter chips
 */

export const TASK_TYPE_STYLES = {
  addressVisit: {
    color: '#47acc3',              // primary
    borderColor: '#47acc3',        // dark-blue
    backgroundColor: '#abe4f1ff',  // quinary
    textColor: '#151515ff',
    label: 'Huisbezoek',
  },

  personaSchedule: {
    color: '#f48183',              // secondary
    borderColor: '#f48183',
    backgroundColor: '#f8c5c6ff',  // tertiary
    textColor: '#151515ff',
    label: 'Medewerker',
  },

  teamSchedule: {
    color: '#277906ff',            // dark-blue
    borderColor: '#277906ff',
    backgroundColor: '#cafeb6ff',  // quinary
    textColor: '#151515',
    label: 'Team',
  },

  activityForm: {
    color: '#998f03ff',            // quaternary
    borderColor: '#998f03ff',
    backgroundColor: '#fff9a3ff',  // tertiary
    textColor: '#151515',
    label: 'Activiteit',
  },

  measureMoment: {
    color: '#a400a4ff',            // quinary
    borderColor: '#a400a4ff',      // primary
    backgroundColor: '#f8b4f8ff',  // tertiary
    textColor: '#151515',
    label: 'Meetmoment',
  },

  // Afspraak die een beheer- of portfolio-omgeving vastlegt bij een van haar
  // projecten. Leeft in de eigen agenda, niet bij het project.
  // AI-CONTEXT: See docs/features/deccos-projectafspraken.md
  projectFollowUp: {
    color: '#206c7f',              // dark teal
    borderColor: '#206c7f',
    backgroundColor: '#c9e9f1ff',
    textColor: '#151515ff',
    label: 'Projectafspraak',
  },

  default: {
    color: '#206c7f',
    borderColor: '#206c7f',
    backgroundColor: '#a8eeffff',
    textColor: '#151515ff',
    label: 'Overig',
  },
};

/**
 * Safe accessor
 */
export const getTaskTypeStyle = (type) => {
  if (!type) return TASK_TYPE_STYLES.default;
  return TASK_TYPE_STYLES[type] || TASK_TYPE_STYLES.default;
};

/**
 * Helper for filter options / iteration
 * ✅ Includes "default" so it can be filtered/shown as well.
 * Puts "default" at the end to keep the UI tidy.
 */
export const TASK_TYPE_OPTIONS = Object.entries(TASK_TYPE_STYLES)
  .sort(([a], [b]) => {
    if (a === 'default') return 1;
    if (b === 'default') return -1;
    return a.localeCompare(b);
  })
  .map(([value, cfg]) => ({
    value,
    label: cfg.label,
  }));
